import React from 'react';

const DiscountTiers = ({ priceInfo, config, documentCount }) => {
  const discountTiers = priceInfo?.discount_tiers || config?.discount_tiers;
  
  if (!discountTiers || !Array.isArray(discountTiers) || discountTiers.length === 0) {
    return (
      <div className="text-center text-muted p-4">
        <i className="bi bi-info-circle display-4 mb-2"></i>
        <div>No hay descuentos configurados</div>
      </div>
    );
  }

  return (
    <div className="row">
      {discountTiers.map((tier, index) => {
        const isActive = documentCount >= tier.minDocuments;
        const isCurrentActive = isActive && (
          index === discountTiers.length - 1 || 
          documentCount < discountTiers[index + 1]?.minDocuments
        );
        
        return (
          <div key={index} className="col-md-6 col-lg-4 mb-3">
            <div className={`card border-2 shadow-sm transition-all ${
              isCurrentActive 
                ? 'border-success bg-success text-white transform-scale-105' 
                : isActive 
                  ? 'border-success bg-light' 
                  : 'border-light bg-white'
            }`}
            style={{
              transform: isCurrentActive ? 'scale(1.05)' : 'scale(1)',
              transition: 'all 0.3s ease'
            }}>
              <div className="card-body p-3 text-center">
                {/* Badge de estado */}
                <div className="mb-2">
                  {isCurrentActive ? (
                    <span className="badge bg-white text-success fw-bold">
                      <i className="bi bi-check-circle-fill me-1"></i>
                      APLICADO
                    </span>
                  ) : isActive ? (
                    <span className="badge bg-success text-white">
                      <i className="bi bi-check me-1"></i>
                      Disponible
                    </span>
                  ) : (
                    <span className="badge bg-light text-muted">
                      <i className="bi bi-lock me-1"></i>
                      Disponible
                    </span>
                  )}
                </div>
                
                {/* Porcentaje de descuento */}
                <div className={`h5 mb-1 fw-bold ${
                  isCurrentActive 
                    ? 'text-white' 
                    : isActive 
                      ? 'text-success' 
                      : 'text-muted'
                }`}>
                  {tier.discount}% OFF
                  {isCurrentActive && (
                    <i className="bi bi-star-fill ms-2 text-warning"></i>
                  )}
                </div>
                
                {/* Cantidad mínima */}
                <div className={`small ${
                  isCurrentActive 
                    ? 'text-white-50' 
                    : isActive 
                      ? 'text-success' 
                      : 'text-muted'
                }`}>
                  {tier.minDocuments?.toLocaleString()}+ docs
                </div>
                                     
                {/* Información para descuento activo */}
                {isCurrentActive && (
                  <div className="mt-2">
                    <small className="text-white-50">
                      <i className="bi bi-lightning-fill me-1"></i>
                      Ahorras S/ {priceInfo?.savings || '0'}
                    </small>
                  </div>
                )}
                
                {/* Para descuentos no alcanzados */}
                {!isActive && (
                  <div className="mt-2">
                    <small className="text-muted">
                      <i className="bi bi-arrow-up me-1"></i>
                      Faltan {(tier.minDocuments - documentCount).toLocaleString()}
                    </small>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DiscountTiers;
